module.exports = __webpack_public_path__ + "img/Jiangxi-power.e362b521.png";